import { render } from "./CardPick.vue?vue&type=template&id=f010ea50&scoped=true"
import script from "./CardPick.vue?vue&type=script&lang=js"
export * from "./CardPick.vue?vue&type=script&lang=js"

import "./CardPick.vue?vue&type=style&index=0&id=f010ea50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f010ea50"]])

export default __exports__